export const FieldCounter = (data = []) => {
  const counts = {
    late: 0,
    ot: 0,
    absent: 0,
    halfDay: 0,
  };

  if (Array.isArray(data)) {
    data.forEach((row = {}) => {
      let statusArr = [];
      if (row && typeof row.status === 'string') {
        statusArr = row.status.toLowerCase().trim().split(', ');
      }

      if (statusArr.includes('half day')) {
        counts.halfDay++;
      }

      if (statusArr.includes('late')) {
        counts.late++;
      }

      if (statusArr.includes('absent')) {
        counts.absent++;
      }

      // Count if 'workedFrom' matches a counted property
      if (row && typeof row.workedFrom === 'string') {
        const workedFrom = row.workedFrom.toLowerCase();
        if (counts.hasOwnProperty(workedFrom)) {
          counts[workedFrom]++;
        }
      }
    });
  }

  return counts;
};
